import React, { useState, useCallback } from 'react';

import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

import Button from 'react-bootstrap/Button';
import { Form, Col } from 'react-bootstrap';

import * as api from 'api/tender';

const calculateAverageCost = tenderQuote => {
  const costs = [
    tenderQuote.benchmark_cost,
    tenderQuote.function_cost,
    tenderQuote.historical_cost.average_cost
  ];
  const filtered = costs.filter(el => {
    return el !== null;
  });
  const average_cost =
    filtered.reduce((a, b) => {
      return a + b;
    }, 0) / filtered.length;
  return average_cost.toFixed(2);
};

const TenderQuote = React.memo(({ match }) => {
  const [error, setError] = useState(null);
  const [currentQuoteResult, setCurrentQuoteResult] = useState({});
  const [loading, setLoading] = useState(false);
  const [percFrom, setPercFrom] = useState(90);
  const [percTo, setPercTo] = useState(110);

  const handleSetPercFrom = useCallback(event => {
    setPercFrom(parseInt(event.target.value));
  }, []);

  const handleSetPercTo = useCallback(event => {
    setPercTo(parseInt(event.target.value));
  }, []);

  const handleSubmit = async event => {
    event.preventDefault();
    const values = [
      'kg',
      'n_of_pallets',
      'pu_zipcode',
      'do_zipcode',
      'pu_datetime',
      'do_datetime',
      'vehicle_type',
      'country_code'
    ].reduce((acc, key) => ({ ...acc, [key]: event.currentTarget[key].value }), {});
    setLoading(true);
    try {
      setError(null);
      setCurrentQuoteResult({});
      const quote = await api.getTenderQuote(values);
      setCurrentQuoteResult(quote);
    } catch (e) {
      console.log(e);
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {!!error && <Alert variant="danger">We got unexpected error: {error.data}</Alert>}
      {!!loading && (
        <div className="mt-4 d-flex justify-content-center">
          <Spinner animation="border" />
        </div>
      )}
      <div>
        <h2 className="mb-3">Tender quote</h2>
        <Form onSubmit={handleSubmit} className="col-sm-6 offset-sm-3">
          <Form.Row>
            <Col>
              <Form.Label>Weight:</Form.Label>
              <Form.Control name="kg" size="sm" type="text" placeholder="kg" required />
            </Col>
            <Col>
              <Form.Label>Number of pallets:</Form.Label>
              <Form.Control
                name="n_of_pallets"
                size="sm"
                type="text"
                placeholder="Number of pallets"
                required
              />
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <Form.Label>Pickup zipcode:</Form.Label>
              <Form.Control
                name="pu_zipcode"
                size="sm"
                type="text"
                placeholder="PU zipcode"
                required
              />
            </Col>
            <Col>
              <Form.Label>Dropoff zipcode:</Form.Label>
              <Form.Control
                name="do_zipcode"
                size="sm"
                type="text"
                placeholder="DO zipcode"
                required
              />
            </Col>
          </Form.Row>
          <Form.Row>
            <Form.Label>Pickup datetime (YYYY-MM-DD HH:mm):</Form.Label>
            <Form.Control
              name="pu_datetime"
              size="sm"
              type="text"
              placeholder="PU datetime"
              required
            />
          </Form.Row>
          <Form.Row>
            <Form.Label>Dropoff datetime (YYYY-MM-DD HH:mm):</Form.Label>
            <Form.Control
              name="do_datetime"
              size="sm"
              type="text"
              placeholder="DO datetime"
              required
            />
          </Form.Row>
          <Form.Row>
            <Form.Label>Vehicle Type:</Form.Label>
            <Form.Control as="select" name="vehicle_type" required>
              <option>trailer</option>
              <option>rigid_truck</option>
              <option>box_van</option>
              <option>van</option>
            </Form.Control>
          </Form.Row>
          <Form.Row>
            <Form.Label>Country:</Form.Label>
            <Form.Control as="select" name="country_code" required>
              <option>ES</option>
              <option>UK</option>
              <option>FR</option>
              <option>NL</option>
            </Form.Control>
            <Button type="submit" disable="{loading}">
              Submit
            </Button>
          </Form.Row>
        </Form>
      </div>
      <div>
        {!!currentQuoteResult.function_cost && (
          <div>
            <h4>Quote results:</h4>
            Function cost: {currentQuoteResult.function_cost} <br />
            Benchmark cost: {currentQuoteResult.benchmark_cost} <br />
            Benchmark Price: {currentQuoteResult.benchmark_price} <br />
            Historical average cost: {currentQuoteResult.historical_cost.average_cost} <br />
            Historical minimum cost: {currentQuoteResult.historical_cost.minimal_cost} <br />
            <h4>Calculations:</h4>
            Average: {calculateAverageCost(currentQuoteResult)} <br />
            <Form>
              <Form.Row>
                <Col>
                  <Form.Label>Percentage from:</Form.Label>
                  <Form.Control
                    name="percFrom"
                    size="sm"
                    type="text"
                    placeholder="% from"
                    required
                    value={percFrom}
                    onChange={handleSetPercFrom}
                  />
                  Price from:{' '}
                  {parseInt((calculateAverageCost(currentQuoteResult) * percFrom) / 100)} <br />
                </Col>
                <Col>
                  <Form.Label>Percentage to:</Form.Label>
                  <Form.Control
                    name="percTo"
                    size="sm"
                    type="text"
                    placeholder="% to"
                    required
                    value={percTo}
                    onChange={handleSetPercTo}
                  />
                  Price to: {parseInt((calculateAverageCost(currentQuoteResult) * percTo) / 100)}{' '}
                  <br />
                </Col>
              </Form.Row>
            </Form>
          </div>
        )}
      </div>
    </>
  );
});

export default TenderQuote;
